module.exports = __webpack_public_path__ + "img/flex.9489062c.png";